import { AfterViewChecked, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ApiService } from '../services/api.service';


@Component({
  selector: 'app-chatbox',
  standalone: false,
  templateUrl: './chatbox.component.html',
  styleUrl: './chatbox.component.scss'
})
export class ChatboxComponent implements OnInit, AfterViewChecked {

  @ViewChild('chatContainer') chatContainer!: ElementRef;

  visible: boolean = false;
  userMessage: string = '';
  isBotTyping: boolean = false;

  chatMessages: {
    text: string;
    fromUser: boolean;
    isSuggestion?: boolean;
    isSuggestionHeader?: boolean;
  }[] = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {}

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  openChatbot() {
    this.visible = true;
  }

  closeChatbot() {
    this.visible = false;
    this.chatMessages = [];
  }

  minimizeChatbot() {
    this.visible = false;
  }

  get hasSuggestions(): boolean {
    return this.chatMessages.some(msg => msg.isSuggestion);
  }

  sendMessage() {

    if (!this.userMessage.trim()) return;

    const payload = { query: this.userMessage };

    this.chatMessages.push({
      text: this.userMessage,
      fromUser: true
    });

    this.userMessage = '';
    this.isBotTyping = true;

    this.api.postAPI(`/qa/chat/`, payload).subscribe(
      (res: any) => {

        this.chatMessages.push({
          text: res.answer,
          fromUser: false
        });

        this.chatMessages = this.chatMessages.filter(
          msg => !msg.isSuggestion && !msg.isSuggestionHeader
        );

        if (res.similar_questions?.length) {

          this.chatMessages.push({
            text: 'Did you mean?',
            fromUser: false,
            isSuggestionHeader: true
          });

          res.similar_questions.forEach((q: string) => {
            this.chatMessages.push({
              text: q,
              fromUser: false,
              isSuggestion: true
            });
          });
        }

        this.isBotTyping = false;

      },
      () => {

        this.chatMessages.push({
          text: 'Something went wrong.',
          fromUser: false
        });

        this.isBotTyping = false;
      }
    );
  }

  selectSuggestion(question: string) {
    this.userMessage = question;
    this.sendMessage();
  }

  scrollToBottom() {
    if (this.chatContainer) {
      this.chatContainer.nativeElement.scrollTop =
        this.chatContainer.nativeElement.scrollHeight;
    }
  }
  

}